import Backbone from 'backbone';

var ServiceHost = Backbone.Model.extend({
    idAttribute: 'value',

    urlRoot: function() {
        return '/modern/system-service/preference/Host.connectApiHost';
    },

    parse: function(response) {
        return response;
    }
});

export default ServiceHost;
